import { TYPE as buttonType } from 'components/Button'
import FormBox from 'components/FormBox'
import Heading from 'components/Heading'
import Icon from 'components/Icon'
import Input from 'components/Input'
import { Modal, ModalHeader } from 'components/Modal'
import { SRPRS } from 'Icon/srprs'
import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import { getSiteCountryICC2, SiteCountry } from '../../data/models/locale'
import { getClient } from '../../data/openapi'
import { AppState } from '../../data/state'
import Content from '../../pages/shared/content'
import { newsletterSignUp } from '../../tracking/actions/newsletterSignUp'

interface RocketModalProps {
  view: boolean
  onDismiss: () => void
  backgroundImage: string
  country: SiteCountry
}

interface RocketModalState {
  firstName: string
  email: string
  success: boolean
  inProgress: boolean
}

class RocketModal extends React.Component<RocketModalProps, RocketModalState> {
  constructor(props: RocketModalProps) {
    super(props)
    this.state = {
      firstName: '',
      email: '',
      success: false,
      inProgress: false,
    }
  }

  public onSubmit = () => {
    newsletterSignUp()
    this.setState({ inProgress: true }, () => {
      const data = {
        first_name: this.state.firstName,
        email: this.state.email,
        site_country: getSiteCountryICC2(this.props.country),
      }
      getClient()
        .then(client => client.apis.bookings.bookings_rocket_signup({ data }))
        .then(() => {
          this.setState({
            success: true,
            inProgress: false,
          })
        })
        .catch(() => {
          this.setState({
            inProgress: false,
          })
        })
    })
  }

  public render() {
    const { view, backgroundImage, onDismiss } = this.props

    if (!view) {
      return null
    }

    return (
      <Modal
        size="xl"
        animationType={'1'}
        backdrop={true}
        color={false}
        sticky={true}
        backgroundImage={backgroundImage}
        onDismiss={() => onDismiss()}
        modalName={`rocketModal`}
      >
        <ModalHeader></ModalHeader>
        <div className="content">
          <Icon icon={SRPRS.rocket} viewBox="0 0 512 512" />
          <Heading>
            <Content contentKey="rocket-heading">Space travel</Content>
          </Heading>
          <p>
            <Content contentKey="rocket-p">Space travel text</Content>
          </p>
          <br />
          {this.state.success ? (
            <Content contentKey="rocket-thanks">
              Thank you for signup up for Space Travel
            </Content>
          ) : (
            <>
              <FormBox
                buttonType={buttonType.plain}
                buttonCutOff={'none'}
                buttonText={
                  <DisplayContent edit={true} addNode contentKey="send">
                    Send
                  </DisplayContent>
                }
                buttonClick={() => {
                  this.onSubmit()
                }}
                inProgress={this.state.inProgress}
              >
                <Input
                  name="first_name"
                  label={
                    <DisplayContent edit={true} contentKey="firstname">
                      First name
                    </DisplayContent>
                  }
                  type="text"
                  value={this.state.firstName}
                  handleChange={firstName => this.setState({ firstName })}
                  styleProps={{ hasFloatingLabel: true }}
                  componentProps={{ required: true }}
                />

                <Input
                  name="email"
                  label={
                    <DisplayContent edit={true} contentKey="email">
                      Email
                    </DisplayContent>
                  }
                  type="email"
                  value={this.state.email}
                  handleChange={email => this.setState({ email })}
                  styleProps={{ hasFloatingLabel: true }}
                  componentProps={{ required: true }}
                ></Input>
              </FormBox>
            </>
          )}
        </div>
      </Modal>
    )
  }
}

export default connect(
  (state: AppState) => ({
    view: state.ui.viewRocketModal,
    country: state.locale.country,
  }),
  dispatch => ({
    onDismiss: () => {
      dispatch(actions.change('ui.viewRocketModal', false))
    },
  }),
)(RocketModal)
